import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createBlock(_component_base_button, _mergeProps({
    weight: "thin",
    lowercase: true,
    size: "micro",
    shape: "soft",
    theme: "default",
    class: ['gfu-comment-streams__button', {'gfu-btn--border-thin': $props.isThin}]
  }, _ctx.$attrs, { "data-qa": "comments-stream:FilterTag" }), {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString($props.name) + " ", 1 /* TEXT */),
      ($props.isSelected)
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 0,
            name: "times",
            class: "gfu-btn__icon gfu-btn__icon--right gfu-btn__icon--light",
            "data-qa": "comment-filter-item:Remove"
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["class"]))
}